import React from 'react';
import { Container, Typography, Box, Paper, Button, Divider } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';

const Impressum: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ 
      minHeight: '100vh', 
      backgroundColor: '#f5f5f5',
      py: 4
    }}>
      <Container maxWidth="md">
        <Button 
          startIcon={<ArrowBackIcon />} 
          onClick={() => navigate('/')}
          sx={{ mb: 3 }}
        >
          Zurück zur Startseite
        </Button>
        
        <Paper 
          elevation={3} 
          sx={{ 
            p: 4, 
            borderRadius: 2,
            backgroundColor: 'white'
          }}
        >
          <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 'bold', mb: 3 }}>
            Impressum
          </Typography>
          
          <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#333', mt: 2 }}>
            Angaben gemäß § 5 TMG
          </Typography>
          <Typography variant="body1" paragraph sx={{ ml: 2 }}>
            Friedrich-Baur-Straße 13<br />
            63150 Heusenstamm<br />
            Deutschland
          </Typography>
          
          <Divider sx={{ my: 2 }} />
          
          <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#333', mt: 2 }}>
            Kontakt
          </Typography>
          <Typography variant="body1" paragraph sx={{ ml: 2 }}>
            Telefon: +49 173 4700004<br />
            E-Mail: info@washprotech.de
          </Typography>
          
          <Divider sx={{ my: 2 }} />
          
          <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#333', mt: 2 }}>
            Vertreten durch
          </Typography>
          <Typography variant="body1" paragraph sx={{ ml: 2 }}>
            Maximilian Büttner<br />
            Maximilian Eichenauer<br />
            Nils Siegfried<br />
            Nicola Grimm
          </Typography>
          
          <Divider sx={{ my: 2 }} />
          
          <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#333', mt: 2 }}>
            Umsatzsteuer-ID
          </Typography>
          <Typography variant="body1" paragraph sx={{ ml: 2 }}>
            folgt
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
};

export default Impressum; 